import { render, staticRenderFns } from "./InactiveAccount.vue?vue&type=template&id=533cdda2&scoped=true"
import script from "./InactiveAccount.vue?vue&type=script&lang=js"
export * from "./InactiveAccount.vue?vue&type=script&lang=js"
import style0 from "./InactiveAccount.vue?vue&type=style&index=0&id=533cdda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533cdda2",
  null
  
)

export default component.exports